import "./DepositDetail.scss"
import { Box } from "@mui/material"
import { format } from "date-fns"
import React from "react"
import { useTranslation } from "react-i18next"
import Text from "src/components/Text"
import { formatLockPeriod, getEndDate } from "../../helpers"

export interface DepositDetailProps {
  apr: string
  multiplier: number
  lockPeriod: number
  hideText?: boolean
}

const DepositDetail = ({
  apr,
  lockPeriod,
  multiplier,
  hideText,
}: DepositDetailProps) => {
  const { t } = useTranslation()
  const endDate = getEndDate(lockPeriod)

  return (
    <Box my={3} className="deposit-detail">
      <Box display="flex" justifyContent="space-between">
        <Text>{t("APR")}</Text>
        <Text ml={1}>{apr}%</Text>
      </Box>
      <Box display="flex" justifyContent="space-between" mt={1}>
        <Text>{t("Multiplier")}</Text>
        <Text ml={1}>{multiplier / 100}x</Text>
      </Box>
      <Box display="flex" justifyContent="space-between" mt={1} mb={2}>
        <Text>{t("Lock End Date")}</Text>
        <Text ml={1} sx={{ wordBreak: "break-all" }}>{`${format(
          endDate,
          "MMM dd, yyyy",
        )}(${formatLockPeriod(lockPeriod)})`}</Text>
      </Box>
      {!hideText && (
        <ul>
          <li>
            <Text>
              {t(
                "You will not be able to withdraw your tokens before the period end date.",
              )}
            </Text>
          </li>
          <li>
            <Text>
              {t(
                "APR figures are estimates provided for your convenience only, and by no means represent guaranteed returns.",
              )}
            </Text>
          </li>
        </ul>
      )}
    </Box>
  )
}

export default DepositDetail
